import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-developper',
  templateUrl: './developper.component.html',
  styleUrls: ['./developper.component.scss']
})
export class DevelopperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
